import { useState } from 'react';

const faqs = [
  {
    q: 'Is there a custom tailor near me?',
    a: 'British Custom Tailors serves clients across all 50 states through our nationwide house call service. We travel directly to your home or office, so you don\'t need to find a local tailor — we bring the full studio experience to you. Call 866-857-8487 to schedule a visit in your area.',
  },
  {
    q: 'Who is the best custom suit tailor in Boston and Massachusetts?',
    a: 'British Custom Tailors has been serving the Greater Boston area — including Wellesley Hills, Newton, Brookline, Cambridge, and surrounding communities — since 1969. Our flagship studio in Wellesley Hills is the premier destination for bespoke tailoring in New England.',
  },
  {
    q: 'Do you offer alterations near me?',
    a: 'Yes. Our alteration services are available through our house call network nationwide. Whether you\'re in New York, Chicago, Los Angeles, Miami, or any other city, we can arrange a visit to assess and complete your alterations. Contact us to confirm availability in your area.',
  },
  {
    q: 'Can I get a custom suit made in New York City?',
    a: 'Absolutely. We regularly serve clients in Manhattan, Brooklyn, and throughout the New York metro area. Our consultants visit homes, apartments, and offices throughout NYC and New Jersey for full custom suit consultations and fittings.',
  },
  {
    q: 'Do you have a tailor in Los Angeles or Southern California?',
    a: 'Yes. We serve clients across Los Angeles, Beverly Hills, Santa Monica, Orange County, and throughout Southern California through our house call service. Call us to arrange a personal consultation at your location.',
  },
  {
    q: 'How does a house call tailor work?',
    a: 'You simply call us or book online, and we schedule one of our expert consultants to visit your location at a time that works for you. They arrive with fabric swatches, measuring tools, and style guides. You select your fabrics, we take your measurements, and your garment is handcrafted and delivered to you — all without leaving your home.',
  },
  {
    q: 'Do you serve clients in Miami, Florida?',
    a: 'Yes, we serve clients throughout South Florida, including Miami, Boca Raton, Fort Lauderdale, Palm Beach, and surrounding areas. Our consultants regularly travel to the region for custom tailoring consultations.',
  },
  {
    q: 'Where is the British Custom Tailors studio located?',
    a: 'Our flagship studio is located in Wellesley Hills, Massachusetts — one of the most prestigious communities in New England. We serve walk-in clients and appointments at this location, as well as traveling to clients across the country through our house call service.',
  },
];

export default function LocationsFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-[#C9A961] text-xs font-bold tracking-widest uppercase mb-3">Voice &amp; AI Search</p>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Frequently Asked <span className="text-[#C9A961]">Location Questions</span>
          </h2>
          <p className="text-xl text-gray-600">
            Common questions from clients searching for tailoring services nationwide
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-100 transition-colors"
              >
                <h3 className="text-base font-semibold text-gray-900 pr-4 leading-snug">
                  {faq.q}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-white border border-gray-200">
                  <i className={`${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'} text-[#C9A961] text-base`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed text-sm border-t border-gray-200 pt-4">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
